import Swiper from "swiper";
import { Autoplay, Navigation, Thumbs } from "swiper/modules";
import imagePreview from "../../components/imagePreview/main";
import { initSolutionCards } from "../../components/solutions/main";

// Product Gallery Thumbs
const galleryThumbs = new Swiper(".product-gallery-thumbs", {
	modules: [Navigation, Thumbs],
	spaceBetween: 4,
	slidesPerView: 4.5,
	freeMode: true,
	watchSlidesProgress: true,
});

// Product Gallery Main
new Swiper(".product-gallery-top", {
	modules: [Navigation, Thumbs],
	thumbs: {
		swiper: galleryThumbs,
	},
});

// Related Products Swiper
new Swiper(".related-products-swiper", {
	modules: [Navigation, Autoplay],
	slidesPerView: 1,
	spaceBetween: 20,
	navigation: {
		nextEl: ".related-products-swiper .swiper-button-next",
		prevEl: ".related-products-swiper .swiper-button-prev",
	},
	breakpoints: {
		640: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
		1024: {
			slidesPerView: 4,
			spaceBetween: 40,
		},
	},
});

// Tabs Logic
const tabBtns = document.querySelectorAll(".tab-btn");
const tabPanes = document.querySelectorAll(".tab-pane");

tabBtns.forEach((btn) => {
	btn.addEventListener("click", () => {
		// Remove active class from all buttons and panes
		for (const b of tabBtns) {
			b.classList.remove("active");
		}
		for (const p of tabPanes) {
			p.classList.remove("active");
		}

		// Add active class to clicked button
		btn.classList.add("active");

		// Show corresponding pane
		const tabId = btn.getAttribute("data-tab");
		const pane = document.getElementById(`tab-${tabId}`);
		if (pane) {
			pane.classList.add("active");
		}
	});
});

const imgs = document.querySelectorAll(
	".product-gallery-top .swiper-slide .preview-icon",
);

imgs.forEach((img) => {
	img.addEventListener("click", () => {
		const index = Array.from(imgs).indexOf(img);
		imagePreview({
			urls: Array.from(imgs).map(
				(i) => i.parentElement?.querySelector("img")?.getAttribute("src") || "",
			),
			index,
		});
	});
});

// 典型应用卡片详情弹窗
initSolutionCards();
